import React from 'react'
import {AsyncTypeahead} from 'react-bootstrap-typeahead'
import {t} from '../../helpers/translate'
import BaseInputComponent from './BaseInputComponent'
import StaticTextComponent from './StaticTextComponent'
import {request} from '../../helpers/request'
let config = require('config');

class AsyncTypeaheadComponent extends BaseInputComponent {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      affiliateCandidates: []
    };
    this.onTypeAffiliateDropDown = this.onTypeAffiliateDropDown.bind(this);
    this.onFindAffiliateResponse = this.onFindAffiliateResponse.bind(this);
  }

  onFindAffiliateResponse(data, statusCode) {
    this.setState({
      affiliateCandidates: data['affiliates'],
      isLoading: false
    });
  }

  onTypeAffiliateDropDown(text) {
    if (text.length < 3) {
      return;
    }
    this.setState({
      isLoading: true
    });
    request(`${config.default.api}/affiliate?name=${text}`, 'GET', null, this.onFindAffiliateResponse);
  }

  onInputChange(text) {
    if (text.length < 3) {
      this.handleChange('');
    }
  }

  render() {
    return (this.props.isStatic ?
                <StaticTextComponent id={this.props.id} value={this.getValue()}/> :
                <AsyncTypeahead
                  className='affiliateList'
                  bsSize='sm'
                  isLoading={this.state.isLoading}
                  labelKey={affiliate => `${affiliate['long_name']}, ${affiliate['short_name']}, ${affiliate['code']}`}
                  onChange={(selected) => this.handleChange(selected.length>0 ? selected[0]['long_name'] : null)}
                  onSearch={this.onTypeAffiliateDropDown}
                  onInputChange={(text) => this.onInputChange(text)}
                  options={this.state.affiliateCandidates}
                  defaultInputValue={this.getValue() || ''}
                  placeholder={t('Enter Affiliate')}
                />
            )
  }
}

export default AsyncTypeaheadComponent;


// WEBPACK FOOTER //
// ./src/components/common/AsyncTypeaheadComponent.js